<p-dialog
  [contentStyle]="{ overflow: 'auto', 'max-height': '60vh', 'min-height': '50vh' }"
  [styleClass]="'sm:col-12 md:col-12 lg:col-9 xl:col-6'"
  [dismissableMask]="false"
  modal="true"
  [(visible)]="visible"
  [closable]="true"
  (onHide)="close()"
  >
  <ng-template pTemplate="header">
    <span class="p-dialog-title">
      {{'Filter_List' | translate}}
    </span>
  </ng-template>

  <div class="grid col-12">
    <field-tools class="col-12 md:col-4 lg:col-6" [dataTitle]="'List' | translate">
      <dm-fieldset-header [backGround]="false"> </dm-fieldset-header>
      <div class="scroll-table">
        <bskfilters
          height="45vh"
          [idRequest]="data?.selectedRequestId"
          [dataBskFilters]="data?.requestList"
          (dataBskFilterSelected)="onClickRequest($event)"
        ></bskfilters>
      </div>
    </field-tools>
    @if (data?.selectedRequest) {
      <field-tools class="col-12 md:col-8 lg:col-6" [dataTitle]="'Filter_Crit' | translate">
        <dm-fieldset-header [backGround]="false"> </dm-fieldset-header>
        <div class="form-group">
          <div class="scroll-table">
            <inputvalue [visuMode]="false" [title]="'Index_B' | translate" [dataVariableList]="data.selectedRequest" [libAction]="false" [editorService]="editorService">
          </inputvalue>
        </div>
      </div>
    </field-tools>
  }
</div>
<ng-template pTemplate="footer">
  <p-checkbox class="left" label="{{'Filter_Auto' | translate}}" [(ngModel)]="filterAuto" binary="true"></p-checkbox>
  <button class="margin" pButton type="button" (click)="onClickFilter(false)" label="{{'Filter_No' | translate}}"></button>
  <button class="margin" pButton type="button" (click)="onClickFilter(true)" label="{{'Filter' | translate}}"></button>
</ng-template>
</p-dialog>
